/* eslint-disable import/prefer-default-export */
import { formValueSelector } from 'redux-form';
import { DATE_OF_BIRTH } from './constants';
import getTravelerFormSectionName from './travelerFormName';
export const getSelected = form => (state, id) => formValueSelector(form)(state, getTravelerFormSectionName(id, DATE_OF_BIRTH)) || null;
//# sourceMappingURL=dateOfBirth.js.map